// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__Hy-lf","modal":"Modal_modal__sEOPt","slide-down":"Modal_slide-down__zoDl9"};